import { type BaseProps, mcn } from "@/utils/baseProps.ts";
import type { ReactNode } from "react";

/** Children of {@link StickyArea} that should not scroll horizontally (eg. non-table elements) */
export function XSticky({ children, ...props }: { children: ReactNode } & BaseProps) {
    return <div {...mcn("sticky left-0 right-0", props)}>{children}</div>;
}
